import { PureComponent } from 'react';
import classNames from 'classnames';
import { SpotSvg } from './SpotSvg';

export interface SpotPillProps {
    type?: 'primary' | 'secondary' | 'positive' | 'negative' | 'warning' | 'info';
    icon?: string;
    isSmall?: boolean;
    isOutline?: boolean;
    iconPosition?: 'left' | 'right';
    children: any;
    onClick?: any;
    color?: string;
    className?: string;
}

export class SpotPill extends PureComponent<SpotPillProps> {
    static defaultProps: SpotPillProps = {
        type: 'secondary',
        children: null,
        iconPosition: 'left',
    };

    render() {
        const { type, children, iconPosition, icon, isOutline, isSmall, color, className } = this.props;
        const style = color ? { backgroundColor: color, borderColor: color } : {};
        return (
            <span
                className={classNames(
                    `spot-pill spot-pill--${type}`,
                    { 'spot-pill--outline': isOutline },
                    { 'spot-pill--small': isSmall },
                    className,
                )}
                style={{ ...style, ...{ margin: '3px' } }}
                onClick={this.props.onClick}
            >
                {icon && iconPosition === 'left' && (
                    <SpotSvg icon={icon} className="spot-pill__icon spot-pill__icon--left" width="12px" height="12px" />
                )}
                {children}
                {icon && iconPosition === 'right' && (
                    <SpotSvg icon={icon} className="spot-pill__icon spot-pill__icon--right" width="12px" height="12px" />
                )}
            </span>
        );
    }
}
